import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useNotes } from "../../Hooks/useNotes";

import { noteActions } from "../../Store/note-slice";
import { signOut } from "firebase/auth";
import { auth } from "../../Services/firebase-config";

import { motion, AnimatePresence } from "framer-motion";
import styles from "../Styles/HomeUI.module.css";

import Notes from "../Atomic/Organisms/Notes";
import OptionBar from "../Atomic/Organisms/OptionBar";
import NoteEditModal from "../Atomic/Organisms/NoteEditModal";

const HomeUI = () => {
  const [showItems, setShowItems] = useState(false);
  const [reload, setReload] = useState(false);
  const [notesArray, setNotesArray] = useState([]);
  const { selectedNote, backdrop } = useSelector((state) => state.note);
  const {userDBId, userParamName} = useSelector((state) => state.ui);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { getNotes, deleteNote, updateNote } = useNotes();

  useEffect(() => {
    const getDataHandler = async () => {
      const notes = await getNotes(userDBId);
      setNotesArray(notes);
      setReload(false);
    };
    userDBId && getDataHandler();
    reload && getDataHandler();
  }, [userDBId, getNotes, reload]);

  const signOutHandler = () => {
    signOut(auth);
    navigate("/", { replace: true });
    window.location.reload(true);
  };

  const toggleDropdown = () => {
    setShowItems(!showItems);
  };

  const selectedNoteHandler = ({ id, text, title }) => {
    dispatch(
      noteActions.setSelectedNote({
        noteId: id,
        noteTitle: title,
        noteText: text,
      })
    );
    dispatch(noteActions.setBackdrop(true));
  };

  const exitModalHandler = () => {
    dispatch(noteActions.setBackdrop(false));
  };

  const saveChangesHandler = (noteNewValues) => {
    updateNote(userDBId, noteNewValues, selectedNote)
    setReload(true)
    dispatch(noteActions.setBackdrop(false));
  };

  const deleteNoteHandler = async (id) => {
    setReload(true);
    deleteNote(userDBId, id);
    dispatch(noteActions.setBackdrop(false));
  };

  return (
    <motion.div className={styles.home}>
      <OptionBar
        params={userParamName}
        logOut={signOutHandler}
        toggleDropdown={toggleDropdown}
        showItems={showItems}
      />
      <Notes selected={selectedNoteHandler} notes={notesArray} />
      <AnimatePresence>
        {backdrop && (
          <motion.div
            className={styles["home--backdrop"]}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.25 }}
            exit={{ opacity: 0 }}
          >
            <NoteEditModal
              exitModal={exitModalHandler}
              saveChanges={saveChangesHandler}
              deleteNote={deleteNoteHandler}
              note={selectedNote}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default HomeUI;
